/* The Novo wordmark, rendered as inline SVG with brand-token fills.
   Pure code-motion from src/App.jsx (Phase 2 group 3). */

import React from 'react';
import { brand } from './brand.js';

export const NovoLogo = () => (
  <svg viewBox="0 0 665.2 229.2" style={{ height: "36px", width: "auto", flexShrink: 0 }}>
    <g>
      <g>
        <polygon fill={brand.prussianBlue} points="17.1,211.8 17.1,46.2 8.3,46.2 8.3,220.8 316.7,220.8 316.7,211.8" />
        <polygon fill={brand.prussianBlue} points="648,16.9 648,182.6 656.9,182.6 656.9,8 348.5,8 348.5,16.9" />
      </g>
      <g>
        <path fill={brand.prussianBlue} d="M200.5,164.4h-17.7l-45.1-55.1l-7.4-11.7h-0.2v66.8h-21V64.3h17.7l45.6,55.1l6.9,11.4h0.2V64.3h21V164.4z"/>
        <path fill={brand.prussianBlue} d="M274.9,165.7c-33.7,0-51.5-20.9-51.5-50.7c0-29.8,17.8-51.9,51.5-51.9c34,0,51.5,22.1,51.5,51.9 C326.4,144.8,308.1,165.7,274.9,165.7z M274.9,81.9c-21.3,0-30.2,13.8-30.2,33.1c0,18.7,8.9,31.9,30.2,31.9 c21.5,0,30.1-13.2,30.1-31.9C305,96.2,296.4,81.9,274.9,81.9z"/>
        <path fill={brand.prussianBlue} d="M444.4,64.3l-45.3,100.1h-18.7L335.1,64.3h23.4l28.2,64.3l3.1,10h0.2l3.2-10l28.2-64.3H444.4z"/>
        <path fill={brand.prussianBlue} d="M504.6,165.7c-33.7,0-51.5-20.9-51.5-50.7c0-29.8,17.8-51.9,51.5-51.9c34,0,51.5,22.1,51.5,51.9 C556.1,144.8,537.8,165.7,504.6,165.7z M504.6,81.9c-21.3,0-30.2,13.8-30.2,33.1c0,18.7,8.9,31.9,30.2,31.9 c21.5,0,30.1-13.2,30.1-31.9C534.7,96.2,526.1,81.9,504.6,81.9z"/>
      </g>
      <g>
        <path fill={brand.prussianBlue} d="M370.8,220.8h-22.8v-32.3h4.8v27.4l-0.5,0.5h18.5V220.8z"/>
        <path fill={brand.prussianBlue} d="M413.6,220.8h-24.7v-32.3h24.7v4.4h-20.4l0.5,0.5v8.5l-0.5,0.5h18.5v4.4h-18.5l0.5,0.5v8.6l-0.5,0.5h20.4 V220.8z"/>
        <path fill={brand.prussianBlue} d="M463.1,220.8H459v-4.1c0,0,0,0-0.1,0c-2.1,2.8-5.9,4.5-10.1,4.5c-10.4,0-16.2-6.3-16.2-16.2 c0-10.2,6.1-16.9,16.5-16.9c4.6,0,9.4,1.2,12.8,4.9l-3.5,3.4c-2.4-3-5.9-3.9-9.3-3.9c-7.9,0-11.6,4.7-11.6,12.4 c0,7.4,3.6,11.8,11.3,11.8c5.8,0,9.7-4.1,9.9-9.5l0.5-0.4h-11v-4.4h14.9V220.8z"/>
        <path fill={brand.prussianBlue} d="M515.1,220.8h-5.2l-3.4-7.5l0.2-0.4h-17.2l0.2,0.4l-3.4,7.5h-5.2l14.6-32.3h4.7L515.1,220.8z M504.6,208.4 l-0.5-0.5l-4.9-11l-0.9-3h-0.1l-0.9,2.9l-5,11l-0.5,0.5H504.6z"/>
        <path fill={brand.prussianBlue} d="M556.1,220.8h-22.8v-32.3h4.8v27.4l-0.5,0.5h18.5V220.8z"/>
      </g>
    </g>
  </svg>
);
